import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the recovery payment screen — shares the View frame with the real content. */
export function UnpaidInvoicesPaymentPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="button" width={40} />
          <Skeleton variant="text" width={220} height={32} />
          {/* The real screen puts its pay button here, which is a fixed full-width bar on mobile.
              Without the slot the layout jumps when content lands. */}
          <View.Actions>
            <Skeleton variant="button" width={180} />
          </View.Actions>
        </View.Header>
        <View.Body>
          <div className="flex flex-col gap-20">
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={140} height={36} />
          </div>

          {/* Stands in for the Stripe card form, which loads its own iframe. */}
          <Skeleton variant="block" height={240} />
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
